import { isVideo } from "../util/file/is-video";
import { ImgproxyOptions } from "./create-imgproxy-url";

export type ImgProxyPreset =
  | "video"
  | "image-hotspots"
  | "header"
  | "share-image"
  | "map-marker";

export function imgProxyGetPreset(
  type: ImgProxyPreset,
  origin: string | undefined
): ImgproxyOptions | undefined {
  if (type === "header") {
    return {
      responsive: {
        targetWidth: 440,
        sizes: [440, 880],
      },
      thumbnailSecond: isVideo(origin) ? 0 : undefined,
    };
  }

  if (type === "video") {
    return {
      width: 400,
      height: 700,
      thumbnailSecond: 0,
    };
  }

  if (type === "image-hotspots") {
    return {
      width: 400,
      height: 700,
      thumbnailSecond: 0,
    };
  }

  if (type === "map-marker") {
    return {
      width: 256,
      height: 256,
      resizeType: "fit",
      autoRotate: true,
    };
  }

  if (type === "share-image") {
    return {
      width: 1200,
      height: 630,
      resizeType: "fill-down",
    };
  }

  return undefined;
}
